import "react-app-polyfill/ie11"; // IE polyfill
import "react-app-polyfill/stable"; // IE polyfill
import { createRoot } from 'react-dom/client'; //import React from "react"; import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import ErrorBoundary from './components/errorBoundary.jsx'; // composant permettant de capter une erreur non-prévue
import "./index.css";
import { ThemeProvider } from '@mui/material/styles';
import getTheme from "./themes/index.js";
//import withAuthent from './redux/containers/defineAuthent.js';
import App from "./app.js";
import WithAuthentMsal from './redux/containers/withAuthentMsal.js';
import WithAuthentNativeApp from './redux/containers/withAuthentNativeApp.js';
//import ForTestingNativeapp from './redux/containers/forTestingNativeApp.js';
import { createBrowserHistory as createHistory } from 'history';
import { Provider } from 'react-redux';
import StoreManager from './redux/store/configureStore.js';
import { createProviderAuthent } from './utils/authentUtils.js';
import URLHelper from './utils/urlHelper.js';
import { LanguageHelper } from './utils/languageHelper.js';
import { IsMaybyNativeHoster } from './utils/platformHelper';
/*import { ConstantsHosters } from './utils/constantsByConfig';
import { CreateNewGuid } from './utils/dateHelper';*/ //nécessaire pour le lancement en mode "simulation" !
import { IsIOS } from './utils/platformHelper'; //juste pour tester sous tous les navigateurs et sous les applis mobile !


let history = undefined;
let userAgentAuthent = undefined;
let store = undefined;
let theme = undefined;
let appRootLoadedFct = () => { return (<App />); };


/* ↓ fonction (hook) permettant de lancer les actions nécessaires avant le lancement de l'application React.js ↓ */
(function beforeReactDomRender() {
    //test la détection de l'os:
    console.log('IsIOS:', IsIOS()); //=> qui va loguer les détection...

    //Gestion de la simulation du lancement de l'appli web depuis l'appli native, je vais simuler un certain nombre de chose !
    //début du code pour la simulation !
    
    /*if (ConstantsHosters.simulateLoadIntoNativeApp === true) { 
        //Pour remettre en place le code testant l'application web, simulant son hébergement dans la WebView de l'application Mobile, 
        // voir l'archivage avant le 30/09/2020 OU celui du 18/01/2022 !
        window.intoNativeApp = true;
        window.ReactNativeWebView = { 
            postMessage: function(messageStr) {
                if (!messageStr) return;

                try {
                    let messageValue = JSON.parse(messageStr);
                    if ((!messageValue) || (!messageValue.type) || (messageValue.type <= 0)) return;
                    
                    switch (messageValue.type) {
                        case 11: { //mt11GetDatasAuthent : l'application web souhaite obtenir les données d'authent (login et pwd au minimum)
                            //on simule une attente correspondant au temps d'affichage de l'écran de saisie et de la saisie utilisateur:
                            const message = { 
                                type: 2,
                                label: 'mt2ReturnDatasAuthent',
                                guidCall: CreateNewGuid(),
                                datas: { 
                                    //pour l'exemple, c'est le criptage du mot de passe du login 'toto@spotifarm.fr' !
                                    login: 'toto@spotifarm.fr',
                                    pwdCrypted: '01926a68cee46286666a6ea6eae066e4', //'I54gr1C357Sup3r' en clair
                                    shaOnePwd: 'f2b4ee42ec3d47bc6dd0ab9d2eea8ca455e7ca89',
                                    ////pour l'exemple, c'est le criptage du mot de passe du login 'contact@spotifarm.fr' en dév/démo !
                                    //login: 'contact@spotifarm.fr', pwdCrypted: '@@', shaOne: '@@@',
                                    createClientBefore: false,
                                    //phone: ..., country: ...,
                                    givenName: 'toto',
                                    name: "toto's name",
                                },
                            };
                            const msgJson = JSON.stringify(message);
                            setTimeout(() => window.postMessage(msgJson), 20000); //20s
                            break;
                        }

                        case 12: { //mt12AuthenticatedEvent : l'application web nous signale que l'authentification a été validé
                            //on met juste une alerte:
                            alert("Native's authentication OK !!!");
                            break;
                        }

                        case 13: { //mt13UpdateAppEvent : l'application web nous signale que l'application native doit se mettre à jour
                            //on met juste une alerte:
                            const msg = `--- L'application native n'est pas à jour. Il faut installer une version > ${messageValue.datas.displayVersion}. En acceptant ce message, on considèrera l'application native comme ayant été mise à jour ---`;
                            alert(msg);
                            
                            //on simule alors le chargement de la nouvelle version:
                            const message = { 
                                type: 1,
                                label: 'mt1OnNativeAppEvent',
                                guidCall: CreateNewGuid(),
                                datas: {
                                    versionMaj: 100,
                                    versionMin: 0,
                                    versionRel: 0
                                },
                            };
                            const msgJson = JSON.stringify(message);
                            setTimeout(() => window.postMessage(msgJson), 500); //0.5s
                            break;
                        }

                        case 14: { //mt14DisconnectEvent : l'application web signale que l'utilisateur veut arrêter l'application
                            //on met juste une alerte:
                            alert("Close Native App !!!");
                            break;
                        }
                        
                        case 15: { //mt15ReinitPwdEvent : l'application web souhaite obtenir les données d'authent (login et pwd au minimum)
                            //on simule une attente correspondant au temps d'affichage de l'écran de saisie et de la saisie utilisateur (dont l'ancien et nouveau mot de passe):
                            const message = { 
                                type: 2,
                                label: 'mt2ReturnDatasAuthent',
                                guidCall: CreateNewGuid(),
                                datas: { 
                                    //pour l'exemple, c'est le criptage du mot de passe du login 'toto@spotifarm.fr' !
                                    login: 'toto@spotifarm.fr',
                                    pwdCrypted: '@@', //'promize-19' en clair
                                    shaOnePwd: '@@@',
                                    oldPwd: '01926a68cee46286666a6ea6eae066e4', //'I54gr1C357Sup3r' en clair
                                    oldShaOne: 'f2b4ee42ec3d47bc6dd0ab9d2eea8ca455e7ca89',
                                    createClientBefore: false, // <= évidamment !
                                },
                            };
                            const msgJson = JSON.stringify(message);
                            setTimeout(() => window.postMessage(msgJson), 25000); //25s
                            break;
                        }
                        
                        case 16: { //mt16AuthentFailedEvent : l'application web nous avertie que l'authent a échoué
                            //on met juste une alerte:
                            alert(`L'authentification a échoué (code: ${messageValue.datas.code} "${messageValue.datas.message}").`);
                            break;
                        }

                        case 17: { //mt17GetRefreshWebApp : l'application web chargée dans l'application native doit être rafraichie (car une mise à jour de cette appli web a été éffectué)
                            //on met juste une alerte:
                            alert("--- En acceptant ce message, on considèrera l'application web comme ayant été rechargée ---");
                            
                            //on simule alors le chargement de la nouvelle version:
                            const message = { 
                                type: 1,
                                label: 'mt1OnNativeAppEvent',
                                guidCall: CreateNewGuid(),
                                datas: {
                                    versionMaj: 100,
                                    versionMin: 0,
                                    versionRel: 0
                                },
                            };
                            const msgJson = JSON.stringify(message);
                            setTimeout(() => window.postMessage(msgJson), 500); //0.5s
                            break;
                        }

                        case 18: { //mt18ClearWakeUpDatas : l'application web signale que les données ont été rechargée (l'application native peut alors supprimer sa date de mise en veille)
                            //on met juste une alerte:
                            alert("Date de sortie de mise en veille supprimée...");
                            break;
                        }
                        
                        case 19: { //mt19ForceNewDatasAuthent : l'application web souhaite obtenir les BONNES données d'authent (login et pwd au minimum)
                            //on simule une attente correspondant au temps d'affichage de l'écran de saisie et de la saisie utilisateur (afin de corriger les données connues):
                            const message = { 
                                type: 2,
                                label: 'mt2ReturnDatasAuthent',
                                guidCall: CreateNewGuid(),
                                datas: { 
                                    //pour l'exemple, c'est le criptage du mot de passe du login 'toto@spotifarm.fr' !
                                    login: 'toto@spotifarm.fr',
                                    pwdCrypted: '01926a68cee46286666a6ea6eae066e4', //'I54gr1C357Sup3r' en clair
                                    shaOnePwd: 'f2b4ee42ec3d47bc6dd0ab9d2eea8ca455e7ca89',
                                    ////pour l'exemple, c'est le criptage du mot de passe du login 'contact@spotifarm.fr' en dév/démo !
                                    //login: 'contact@spotifarm.fr', pwdCrypted: '@@', shaOne: '@@@',
                                    createClientBefore: false,
                                    //phone: ..., country: ...,
                                },
                            };
                            const msgJson = JSON.stringify(message);
                            setTimeout(() => window.postMessage(msgJson), 20000); //20s
                            break;
                        }

                        case 20: { //mt20ChangeLanguage : @@
                            alert(`Mobile would change language for '${messageValue.datas.language}'`);
                            break;
                        }

                        case 21: { //mt21ReinitPwdEvent : @@
                            alert('Re-init password process.');
                            break;
                        }

                        case 22: { //mt22CloseAppEvent : ...
                            alert('Good-bye !!!');
                            break;
                        }

                        case 23: { //mt23ClientPZfundEvent : ...
                            alert(`client authenticated and fund '${messageValue.datas.email} (ID:${messageValue.datas.clientId})`);
                            break;
                        }

                        case 24: { //mt24ShowThisUrlEvent : ...
                            alert(`URL to show: '${messageValue.datas}'`);
                            break;
                        }

                        case 25: { //mt25AskPurchaseByStore : ...
                            let skuToUse = undefined;
                            if (messageValue.datas) {
                                skuToUse = (IsIOS() === true) ? messageValue.datas.appleId : messageValue.datas.googleId;
                            }
                            if ((!skuToUse) || (skuToUse === '')) skuToUse = 'com.promize.demospotifarm.ggl.modulation';
                            
                            //on simule une attente correspondant au temps d'affichage des écrans d'achat et de l'activité de l'utilisateur pour...
                            // //soit valider le paiement:
                            // const message = { 
                            //     type: 7,
                            //     label: 'mt7ReturnPurchaseResult',
                            //     guidCall: CreateNewGuid(),
                            //     datas: { 
                            //         purchaseInfos: {    //objet retourné par le module 'react-native-iap', typé 'SubscriptionPurchase' 
                            //             // avec les props suivantes: 'productId', 'transactionId', 'transactionDate', 'transactionReceipt', 'purchaseToken'
                            //             productId: skuToUse, 
                            //             transactionId: '2000000081493655', 
                            //             transactionDate: '1655372932000.0',
                            //             transactionReceipt: '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',
                            //             purchaseToken: 'MIIUP_token_bidon',
                            //         },
                            //         errorInfos: undefined,
                            //     },
                            // };//
                            //soit transmettre un message d'erreur:
                            const message = { 
                                type: 7,
                                label: 'mt7ReturnPurchaseResult',
                                guidCall: CreateNewGuid(),
                                datas: { 
                                    purchaseInfos: undefined,
                                    errorInfos: "je suis un message d'erreur! Grrrrrr",
                                    //errorInfos: { code: 'E_SERVICE_ERROR', message: "je suis le message d'erreur de cet objet 'erreur'. Grrrrrr" }, //autres codes : "E_BILLING_RESPONSE_JSON_PARSE_ERROR"; "E_DEFERRED_PAYMENT"; "PROMISE_BUY_ITEM"
                                },
                            };//
                            const msgJson = JSON.stringify(message);
                            setTimeout(() => window.postMessage(msgJson), 20000); //20s
                            break;
                        }

                        case 26: { //mt26ClientUpgraded : ...
                            alert('!!! Congratulation !!!');
                            break;
                        }

                        case 27: { //mt27RemoveClientandDatas : ...
                            alert("Ok... Je t'oublie !");
                            break;
                        }

                        default: {
                            alert(`message from Web App : ${messageValue.type}-${messageValue.label}`);
                            break;
                        }
                    }
                } catch (error) {}
            },
        }; 

        //Déclencheur retardé pour simuler l'envoi par l'appli native des données de versioning suite au chargement de l'application:
        //on simule une attente correspondant au temps d'affichage de l'écran de saisie et de la saisie utilisateur:
        const messageOne = {
            type: 1,
            label: 'mt1OnNativeAppEvent',
            datas: {
                versionMaj: 100,
                versionMin: 0,
                versionRel: 0
            },
        };
        const msgJsonOne = JSON.stringify(messageOne);
        setTimeout(() => {
            window.postMessage(msgJsonOne)
        }, 20000); //20s      
    }*/ //fin du code pour la simulation !
    
    URLHelper.saveURLParameters(); //lecture + enregistrement des paramètres URL d'entrée
    LanguageHelper.onInitLanguage(); // permet d'initialiser automatiquement la langue (langue du navigateur)
    
    /* ↓ détermine si l'application Web se trouve dans l'application Mobile (sinon, dans un navigateur...potentiellement du mobile mais pas important dans ce cas) ↓ */
    const subUrlFromNativeApp = URLHelper.getURLParameter('FromNativeApp', false); // Nécessaire car 'window.intoNativeApp' et 'window.ReactNativeWebView' ne sont pas encore présents !!!
    const isOnNativeApp = ((subUrlFromNativeApp === 1) || (IsMaybyNativeHoster() === true)) ? true : false;
    
    /* ↓ création des différents objets nécessaires à l'application ↓ */
    history = createHistory(); //← ON ne peut utiliser le BrowserRouter directement - solution de remplacement ←
    userAgentAuthent = createProviderAuthent(isOnNativeApp); //← création de l'objet msal ⚠️ - le mécanisme d'authentification (OAuth 2.0) est lancé !
    store = StoreManager.configureStore({}, history, userAgentAuthent); //← configuration du store
    theme = getTheme();
    
    appRootLoadedFct = () => { 
        return (isOnNativeApp === true) ? // l'application web se trouve-elle dans l'application native ? ou pas! 
            (<WithAuthentNativeApp history={history} userAgentAuthent={userAgentAuthent} />) : 
            (<WithAuthentMsal history={history} userAgentAuthent={userAgentAuthent} />); };

        //return (<ForTestingNativeapp history={history} userAgentAuthent={userAgentAuthent} />); }; //pour tester que l'on reçoit bien les infos lors du lancement (avant chargement de l'appli ReactJs)
})();

/*{(appRootLoaded === true) ? <App history={history} userAgentAuthent={userAgentAuthent} /> : <AppWithoutAuthent />}*/

/*ReactDOM.render(
        <ThemeProvider theme={theme}>
            <ErrorBoundary>
                <Provider store={store}>
                    <Router history={history}>
                        {appRootLoadedFct()}
                    </Router>
                </Provider>
            </ErrorBoundary>
        </ThemeProvider>
    , document.getElementById("root")
);*/ //code avant la prise en compte de l'avertissement dans la console !
//Cf. https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-client-rendering-apis
/* ↓ fonction (hook) permettant d'injecter le visuel de l'application React.js ↓ */
(function renderReactApp() {
    const container = document.getElementById('root');
    if (container) {
        const root = createRoot(container); // createRoot(container!) if you use TypeScript
        if (root) {
            root.render(
                <ThemeProvider theme={theme}>
                    <ErrorBoundary>
                        <Provider store={store}>
                            <Router history={history}>
                                {appRootLoadedFct()}
                            </Router>
                        </Provider>
                    </ErrorBoundary>
                </ThemeProvider>
            );
        }
        //elsee //Aie !!!
    }
    //elsee //Aie !!!
})();
